import { Platform } from 'react-native';

export const SIDEBAR_BREAKPOINT = 864;
export const SIDEBAR_WIDTH = 200;

/**
 * Returns the available content width for a given window width,
 * accounting for the sidebar on desktop web.
 */
export function getContentWidth(windowWidth: number): number {
  const hasSidebar = Platform.OS === 'web' && windowWidth >= SIDEBAR_BREAKPOINT;
  return hasSidebar ? windowWidth - SIDEBAR_WIDTH : windowWidth;
}
